import PageSpinner from "../../components/spinner/page";
import Score from "../../components/product/score";
import ImageSlider from "../../components/product/imageSlider";
import React, {useEffect, useState} from "react";
import { useRouter } from 'next/router';
import Page from "../../lib/page";
import MetaData, {Type} from "../../components/metadata";
import IngredientList from "../../components/ingredientList";
import TraceList from "../../components/traceList";
import NutrientList from "../../components/nutrientList";
import ProductList from "../../components/productList";
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { useTranslation } from 'next-i18next';
import ScoreExplained from "../../components/scoreExplained";
import Embed from "../../components/embed";
import Share from "../../components/share";
import Footer from "../../components/footer";
import Header from "../../components/header";
import Edit from "../../components/edit";
import SourceList from "../../components/sourceList";
import Media from "../../components/media";
import ProductAPI from "../../lib/api/product";
import Link from "next/link";
import IngredientTypeList from "../../components/ingredientTypeList";
import LabelList from "../../components/labelList";
//import ProductData from "../../lib/sitemap/creator/data/product.mjs";
import Breadcrumb from "../../components/breadcrumb";
import SingleScore from "../../components/score";
//import ScoreProgress from "../../components/progress/scoreProgress";
//import StoreSlider from "../../components/storeSlider";

/**
 *
 * @param props
 * @returns {JSX.Element}
 * @constructor
 */
export default function Product(props) {
    const router = useRouter();
    const { t } = useTranslation();

    // fallback
    if (router.isFallback) {
        return <PageSpinner />
    }

    // init variables
    const imageURL = props.product.images[0] ? props.product.images[0].url : process.env.logoURL;


    // stores
    /*const stores = [
        {
            image: {
                alt: "Gorrillas",
                url: "flags/at.svg",
                width: 128,
                height: 128,
                priority: true
            },
            name: "Gorrillas",
            urls: {
                website: "#",
                findStore: "#",
                buyOnline: "#"
            }
        },
        {
            image: {
                alt: "REWE",
                url: "flags/ch.svg",
                width: 128,
                height: 128,
                priority: false
            },
            name: "REWE",
            urls: {
                website: "#",
                findStore: "#",
                buyOnline: "#"
            }
        },
        {
            image: {
                alt: "Penny",
                url: "flags/de.svg",
                width: 128,
                height: 128,
                priority: false
            },
            name: "Penny",
            urls: {
                website: "#",
                findStore: "#",
                buyOnline: "#"
            }
        }
    ];*/

    // sources
    const imageLocale = imageURL.match(/.*front_(.{2})/);
    const sources = [
        {
            description: t('images'),
            name: 'Open food facts',
            url: 'https://' + encodeURIComponent(props.country.toLowerCase()) + '.openfoodfacts.org/cgi/product_image.pl?code=' + encodeURIComponent(props.product.code) + '&id=front' + (imageLocale ? '_' + imageLocale[1] : ''),
            licence: {
                name: 'Creative Commons Attribution-Share Alike 3.0 Unported Licence',
                url: 'https://creativecommons.org/licenses/by-sa/3.0/deed.en'
            }
        },
        {
            description: t('data'),
            name: 'Open food facts',
            url: 'https://' + encodeURIComponent(props.country.toLowerCase()) + '.openfoodfacts.org/product/' + encodeURIComponent(props.product.code),
            licence: {
                name: 'Open Database License (ODbL)',
                url: 'https://opendatacommons.org/licenses/odbl/1-0/'
            }
        },
        {
            description: t('data'),
            name: t('own.information'),
            url: null,
            licence: null
        }
    ];

    const brand = props.product.brands[props.product.brands.length - 1];
    const company = brand.company;

    // embed code
    const embedURL = process.env.url + '/' + props.locale + '/product/embed/' + encodeURIComponent(props.product.id)
    props.product.embed = '<iframe width="320" height="320" src="' + embedURL + '" title="' + process.env.APP_NAME + ' Score ' + props.product.title + '" frameborder="0" style="border: 0"></iframe>';

    // render
    return (
        <>
            {/* Metadata */}
            {/*title={t('product.title', { ns: 'glossary', title: props.product.title})}*/}
            <MetaData
                type={Type.Website}
                title={props.product.title}
                description={t('product.lead', { ns: 'glossary', title: props.product.title})}
                keywords={[props.product.title]}
                imageURL={imageURL}
                urlOnlyForThisCountry={true}
                canonical={false}
            />

            {/* Header */}
            <Header />

            {/* Content */}
            <div className="container p-4 pt-3 pb-5 ms-xxl-5">

                {/* Breadcrumb */}
                <Breadcrumb items={props.breadcrumbs} lastItemDeactivated={false} />

                {/* Header */}
                <div className="row">
                    {/* Title */}
                    <h1 className="pb-2 mt-3 text-center text-md-start">
                        <small className="text-muted">{t('how.healthy.is')}<br /></small>
                        {props.product.title}

                        {/* Symbol */}
                        {/*<svg xmlns="http://www.w3.org/2000/svg" width="32" height="32" fill="currentColor"
                             className="bi bi-egg-fried ms-1 me-1" viewBox="0 0 16 16">
                            <path d="M8 11a3 3 0 1 0 0-6 3 3 0 0 0 0 6z"/>
                            <path
                                d="M13.997 5.17a5 5 0 0 0-8.101-4.09A5 5 0 0 0 1.28 9.342a5 5 0 0 0 8.336 5.109 3.5 3.5 0 0 0 5.201-4.065 3.001 3.001 0 0 0-.822-5.216zm-1-.034a1 1 0 0 0 .668.977 2.001 2.001 0 0 1 .547 3.478 1 1 0 0 0-.341 1.113 2.5 2.5 0 0 1-3.715 2.905 1 1 0 0 0-1.262.152 4 4 0 0 1-6.67-4.087 1 1 0 0 0-.2-1 4 4 0 0 1 3.693-6.61 1 1 0 0 0 .8-.2 4 4 0 0 1 6.48 3.273z"/>
                        </svg>*/}
                    </h1>

                    {/* Brand */}
                    <h2 className={'h6 mb-4 pb-3 text-center text-md-start'}>
                        <span>{t('brand')}: </span>
                        <Link href={'/brand/' + encodeURIComponent(brand.id)}>
                            {brand.name}
                        </Link>
                    </h2>

                    {/* Company */}
                    {company
                        ?
                        <h2 className={'h6 mb-4 pb-3 text-center text-md-start'}>
                            <span>{t('company')}: </span>
                            <Link href={'/company/' + encodeURIComponent(company.id)}>
                                {company.name}
                            </Link>
                        </h2>
                        : ''
                    }

                    <div className="col-md-7 col-lg-5 col-xxl-4 text-md-start">
                        {/* Score */}
                        <div className="w-100 d-inline-flex justify-content-center justify-content-md-start mb-3">
                            <Score link={''} target={'_self'} score={props.product.score} nutrientScore={props.product.scores.nutrients} ingredientScore={props.product.scores.ingredients} />
                        </div>

                        {/* Ingredient-Types */}
                        <div className="d-flex justify-content-center justify-content-md-start mb-4 pb-md-2">
                            <IngredientTypeList
                                id={'product-' + props.product.id}
                                singular={false}
                                ingredientTypes={props.product.ingredientTypes}
                            />
                        </div>

                        {/* Category */}
                        {props.product.categories && props.product.categories.length > 0 ?
                            <div className={'text-center text-md-start mb-4 pb-md-1'}>
                                <Link href={'/category/' + props.product.categories[props.product.categories.length - 1].id} className={"text-decoration-none"}>
                                    <SingleScore size={"small"} value={props.product.categories[props.product.categories.length - 1].score} />
                                    {/*<span
                                        className="small ms-1"
                                        dangerouslySetInnerHTML={{ __html: t('avg.category.score', { ns: 'glossary', category: props.product.categories[props.product.categories.length - 1].translation})}}
                                    />*/}
                                    <b className={'ms-2'}><u>{props.product.categories[props.product.categories.length - 1].translation}</u></b>
                                </Link>
                            </div>
                            : ''
                        }

                        {/* Score explained */}
                        <div className="d-flex justify-content-center justify-content-md-start mb-4 pb-md-1">
                            <ScoreExplained />
                        </div>
                    </div>

                    {/* Media & Control */}
                    <div className="col-12 col-md-5 col-lg-3 mb-3 mb-md-0 mt-4 mt-md-0 text-center">
                        {/* Images */}
                        {
                            'true' === process.env.debug
                            ? props.product.images.length
                                ? <ImageSlider images={props.product.images} />
                                : ''
                            : props.product.images.length
                                ?
                                    <Media
                                        data={
                                            {
                                                type: 'image',
                                                url: props.product.images[0].url,
                                                description: props.product.title,
                                                loader: true,
                                                height: props.product.images[0].height,
                                                width: props.product.images[0].width,
                                                priority: true
                                            }
                                        }
                                        figure={false}
                                    />
                                : ''
                        }

                        {/* Share and Embed */}
                        <div className="row justify-content-center m-0 p-0 mt-4">
                            <Share imageURL={imageURL} />
                            {'true' === process.env.debug ? <Edit id={props.product.id} /> : ''}
                            <Embed code={props.product.embed} />
                        </div>
                    </div>
                </div>

                {/* Nutrients */}
                <div id={'nutrients'} className={'mt-5 pt-4 col-12 col-lg-6'}>
                    <h2>{t('nutrients')}</h2>
                    <h3 id="energy" className="h4 fw-normal">{t('energy')} <b>{props.product.specifics.energy_kcal}</b> {t('kcal')} <small className="text-muted">{t('per 100g')}</small></h3>
                    {/*<ScoreProgress values={{green: 22, yellow: 40, red: 38}} />*/}
                    <NutrientList nutrients={props.product.nutrients} />
                </div>

                {/* Ingredients */}
                <div id={'ingredients'} className={'mt-5 pt-4 pb-1 col-12 col-lg-6'}>
                    <h2>{t('ingredients')}</h2>
                    {/*<ScoreProgress values={{green: 0, yellow: 0, red: 100}} />*/}
                    <IngredientList ingredients={props.product.ingredients} />
                </div>

                {/* Traces */}
                {props.product.traces && props.product.traces.length ?
                <div id={'traces'} className={'mt-5 pt-4 pb-1 col-12 col-lg-6'}>
                    <h2>{t('possible.traces')}</h2>
                    <TraceList traces={props.product.traces} />
                </div> : ''
                }

                {/* Stores */}
                {/*<div id={'stores'} className={'mt-5 pt-4 col-12 col-lg-6'}>
                    <h2 className={'mb-3'}>{t('stores')}</h2>
                    <StoreSlider stores={stores} />
                </div>*/}

                {/* Similar Products */}
                {props.alternatives.length
                    ?
                    <div id={'alternatives'} className={'mt-5 pt-4 col-12 col-lg-9'}>
                        <h2 className="pb-2">{t('healthier.alternatives')}</h2>
                        <ProductList id={'alternative-products'} products={props.alternatives} />
                    </div>
                    : ''
                }

                {/* Labels */}
                {props.product.labels && props.product.labels.length ?
                    <div id={'labels'} className={'mt-5 pt-3 pt-md-1 pb-3 col-12 col-lg-8 col-xxl-7'}>
                        <h2>{t('labels')}</h2>
                        <LabelList labels={props.product.labels} />
                    </div> : ''
                }

                {/* Source */}
                <div id={'sources'} className={'mt-5 pt-4'}>
                    <h2>{t('sources')}</h2>
                    <SourceList
                        sources={sources}
                        align={'start'}
                    />
                </div>
            </div>

            {/* Footer */}
            <Footer />
        </>
    )
}

/**
 *
 * @param productAPI
 * @param locale
 * @param id
 * @param score
 * @param ingredientTypes
 * @param category
 * @returns {Promise<*[]>}
 */
async function selectAlternatives(
    productAPI,
    locale,
    id,
    score,
    ingredientTypes,
    category,
) {
    let alternatives = [];

    const data = await productAPI.selectList(
        '',
        'score_desc',
        Math.min(score + 1, 100),
        '',//ingredientTypes,
        '',
        1,
        category.id,
        '',
        '',
        '',
        7
    );

    // check if response is successful
    if(data && 'ok' === data.header.status && data.footer.results > 0) {
        data.body.products.forEach(function(product) {
            // skip the product for which we are searching alternatives
            // or which have the same or less score
            if(
                product.id === id ||
                product.score <= score
            ) {
                return;
            }

            // add the product
            alternatives.push({
                id: product.id,
                title: product.title,
                link: '/' + locale + '/product/' + encodeURIComponent(product.id),
                score: product.score,
                ingredientTypes: product.ingredientTypes
            })
        })
    }

    // we only need six, items in case we have seven,
    // because the current product was not part of the response
    if(alternatives.length > 6) {
        alternatives.pop();
    }

    return alternatives;
}

/**
 *
 * @param context
 * @returns {Promise<{props: {}}>}
 */
export async function getStaticProps(context) {
    let page = new Page;
    page.init(context.locale);

    let productAPI = new ProductAPI(
        page.language,
        page.country
    );

    let product = {};
    const data = await productAPI.selectById(context.params.id);

    if(data && 'ok' === data.header.status && data.body.product) {
        product = data.body.product
        product.embed = ''
    } else {
        throw Error('Unable to retrieve product');
    }

    // select alternatives
    let alternatives = [];
    if(product.categories.length) {
        alternatives = await selectAlternatives(
            productAPI,
            context.locale,
            product.id,
            product.score,
            [],
            product.categories[product.categories.length - 1]
        );
    }

    // init breadcrumb
    let breadCrumbItems = [];
    for (let category in product.categories) {
        breadCrumbItems.push(
            {
                url: '/category/' + encodeURIComponent(product.categories[category].id),
                name: product.categories[category].translation
            }
        );
    }

    return {
        props: {
            ...(await serverSideTranslations(context.locale, ['common', 'languages', 'countries', 'glossary', 'nutrients', 'ingredients', 'traces', 'ingredient-types'])),
            "product": product,
            "language": page.language,
            "country": page.country,
            "locale": page.locale,
            "alternatives": alternatives,
            "breadcrumbs": breadCrumbItems
        }, // will be passed to the page component as props
        revalidate: 86400, // In seconds
    };
}

/**
 *
 * @returns {Promise<{paths: *[], fallback: boolean}>}
 */
export async function getStaticPaths() {
    let paths = [];

    /*const languages = process.env.LANGUAGES.split(" ");
    const countries = process.env.COUNTRIES.split(" ");

    let productData = new ProductData(
        process.env.url,
        languages,
        countries
    );

    const products = await productData.create();
    products.forEach(function(product) {
        product.alternates.forEach(function(alternate) {
            // only use locales with country-codes as well
            if(5 === alternate.locale.length) {
                const id = alternate.url.match(/.*\/product\/(.*)/);
                paths.push(
                    {
                        params: { id: id[1] },
                        locale: alternate.locale
                    }
                );
            }
        });
    });*/

    return {
        paths: paths,
        fallback: true
    };
}